const topicItems = [
  { label: '苍穹之刃', heat: '9.8万讨论', icon: 'ri-fire-line' },
  { label: '暗夜追光者', heat: '8.2万讨论', icon: 'ri-moon-line' },
  { label: '国产悬疑', heat: '7.5万讨论', icon: 'ri-search-eye-line' },
  { label: '古装剧推荐', heat: '6.9万讨论', icon: 'ri-vip-crown-line' },
  { label: '高分韩剧', heat: '6.3万讨论', icon: 'ri-heart-line' },
  { label: '4K修复经典', heat: '5.8万讨论', icon: 'ri-hd-line' },
  { label: '暑期档', heat: '5.4万讨论', icon: 'ri-sun-line' },
  { label: '科幻大片', heat: '4.9万讨论', icon: 'ri-rocket-line' },
  { label: '纪录片精选', heat: '4.6万讨论', icon: 'ri-earth-line' },
  { label: '动画电影', heat: '4.2万讨论', icon: 'ri-emotion-line' },
  { label: '日剧新番', heat: '3.8万讨论', icon: 'ri-flag-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">观众们在热烈讨论的影视话题，看看大家都在聊什么</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((t) => (
            <div
              key={t.label}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${t.icon} text-sm text-primary-500 group-hover:text-primary-600`}></i>
              </div>
              <span className="text-sm text-foreground-700 whitespace-nowrap">{t.label}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{t.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}